// Organization settings page V2
import noop from 'lodash/noop';
import { createActions } from 'redux-actions';

export const organizationActions = createActions(
  {
    ORGANIZATION_V2_EDIT: [
      (payload) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
    ORGANIZATION_V2_UPLOAD_AVATAR: [
      (payload) => payload,
      (payload, resolve = noop, reject = noop) => ({ resolve, reject }),
    ],
  },

  'ORGANIZATION_V2_GET',
  'ORGANIZATION_V2_GET_SUCCEEDED',
  'ORGANIZATION_V2_GET_FAILED',

  // @TODO: implement call for feature flags https://dixa-product.atlassian.net/browse/TEAMS-3673
  'ORGANIZATION_V2_GET_FEATURE_FLAGS',
  'ORGANIZATION_V2_GET_FEATURE_FLAGS_SUCCEEDED',
  'ORGANIZATION_V2_GET_FEATURE_FLAGS_FAILED',

  'ORGANIZATION_V2_GET_PRESIGNED_AVATAR_URL',
  'ORGANIZATION_V2_GET_PRESIGNED_AVATAR_URL_SUCCEEDED',
  'ORGANIZATION_V2_GET_PRESIGNED_AVATAR_URL_FAILED',

  'ORGANIZATION_V2_EDIT_SUCCEEDED',
  'ORGANIZATION_V2_EDIT_FAILED',

  'ORGANIZATION_V2_UPLOAD_AVATAR_SUCCEEDED',
  'ORGANIZATION_V2_UPLOAD_AVATAR_FAILED',
);
